import React from 'react';
import { WizardComponentProps } from 'react-albus';
import styled from 'styled-components';
import { LinkButton } from '../../../../../CommonComponents/Button';
import { StyledTitle as Title } from '../../styles';
import { STEP_IDS } from './constants';

const StyledLinkButton = styled(LinkButton)`
  font-weight: ${props => (props.isActive ? '600' : 'normal')};
  color: ${props => (props.isActive ? 'inherit' : '#979797')};
`;

const NavigationItems = styled.ul`
  margin: 32px 0 0 0;
  padding: 0;
  list-style-type: none;

  li + li {
    margin-top: 24px;
  }
`;

export const SideNavigation: React.FC<WizardComponentProps> = ({
  wizard: {
    push,
    step: { id: currentStepId },
    steps,
  },
}) => {
  const currentStepIdIndex = steps.findIndex(({ id }) => currentStepId === id);

  return (
    <div>
      <Title>Edit CMAs</Title>

      <NavigationItems>
        <li>
          <StyledLinkButton
            isActive={currentStepId === STEP_IDS.SELECT_ASSET_CLASSES}
            onClick={() => push(STEP_IDS.SELECT_ASSET_CLASSES)}
            disabled={currentStepIdIndex < 0}
          >
            1. Select your asset classes
          </StyledLinkButton>
        </li>
        <li>
          <StyledLinkButton
            isActive={currentStepId === STEP_IDS.NAME_CUSTOM_ASSET_CLASSES}
            onClick={() => push(STEP_IDS.NAME_CUSTOM_ASSET_CLASSES)}
            disabled={currentStepIdIndex < 1}
          >
            2. Name custom asset classes
          </StyledLinkButton>
        </li>
        <li>
          <StyledLinkButton
            isActive={currentStepId === STEP_IDS.SET_RETURNS_AND_VOLATILITIES}
            onClick={() => push(STEP_IDS.SET_RETURNS_AND_VOLATILITIES)}
            disabled={currentStepIdIndex < 2}
          >
            3. Set returns and volatilities
          </StyledLinkButton>
        </li>
        <li>
          <StyledLinkButton
            isActive={currentStepId === STEP_IDS.IMPORT_CORRELATION_MATRIX}
            onClick={() => push(STEP_IDS.IMPORT_CORRELATION_MATRIX)}
            disabled={currentStepIdIndex < 3}
          >
            4. Import correlation matrix
          </StyledLinkButton>
        </li>
      </NavigationItems>
    </div>
  );
};
